export enum HistoryEventType {
  JOB_CREATED = 'job_created',
  ONLINE_PAYMENT_REQUEST_CREATED = 'online_payment_request_created',
  ONLINE_PAYMENT_SENT = 'online_payment_sent',
  ONLINE_PAYMENT_ACCEPTED = 'online_payment_accepted',
  ONLINE_PAYMENT_DECLINED = 'online_payment_declined',
  ONLINE_PAYMENT_REQUEST_DECLINED = 'online_payment_request_declined',
  ONLINE_PAYMENT_CANCELED_SYSTEM = 'online_payment_canceled_system',
  ONLINE_PAYMENT_REQUEST_CANCELED = 'online_payment_request_canceled',
  RECEIVED_JOB = 'received_job',
  WILL_CALL_CUSTOMER = 'will_call_customer',
  MEETING_SCHEDULED = 'meeting_scheduled',
  MEETING_DONE = 'meeting_done',
  SENT_QUOTE = 'sent_quote',
  QUOTE_ACCEPTED = 'quote_accepted',
  JOB_STARTED = 'job_started',
  JOB_COMPLETED = 'job_completed',
  JOB_WILL_NOT_BE_COMPLETED = 'job_will_not_be_completed'
}

interface HistoryEventRecordCommon {
  eventDate: string;
  isDisabled: boolean;
}

interface HistoryEventRecordGeneral extends HistoryEventRecordCommon {
  category: 'general';
  eventType: HistoryEventType.JOB_CREATED;
  customerMessage: string;
  customerExtraMessage: string;
}

interface HistoryEventRecordOnlinePayment extends HistoryEventRecordCommon {
  category: 'customer_online_payment';
  eventType:
    HistoryEventType.ONLINE_PAYMENT_REQUEST_CREATED
    | HistoryEventType.ONLINE_PAYMENT_SENT
    | HistoryEventType.ONLINE_PAYMENT_ACCEPTED
    | HistoryEventType.ONLINE_PAYMENT_DECLINED
    | HistoryEventType.ONLINE_PAYMENT_REQUEST_DECLINED
    | HistoryEventType.ONLINE_PAYMENT_CANCELED_SYSTEM
    | HistoryEventType.ONLINE_PAYMENT_REQUEST_CANCELED;
  proMessage?: string;
  proExtraMessage?: string;
  customerMessage?: string;
  customerExtraMessage?: string;
}

interface HistoryEventRecordBookNowStatus extends HistoryEventRecordCommon {
  category: 'book_now_status';
  eventType:
    HistoryEventType.RECEIVED_JOB
    | HistoryEventType.WILL_CALL_CUSTOMER
    | HistoryEventType.MEETING_SCHEDULED
    | HistoryEventType.MEETING_DONE
    | HistoryEventType.SENT_QUOTE
    | HistoryEventType.QUOTE_ACCEPTED
    | HistoryEventType.JOB_STARTED
    | HistoryEventType.JOB_COMPLETED
    | HistoryEventType.JOB_WILL_NOT_BE_COMPLETED;
  proMessage?: string;
  proExtraMessage?: string;
  customerMessage?: string;
  customerExtraMessage?: string;
}

export type BidHistoryEventRecord = HistoryEventRecordBookNowStatus | HistoryEventRecordOnlinePayment;
export type JobHistoryEventRecord = HistoryEventRecordGeneral | HistoryEventRecordOnlinePayment;
